/**
 * Generated by orval v6.28.2 🍺
 * Do not edit manually.
 * Maybern
 * Maybern API
 * OpenAPI spec version: 0.0.0
 */
import {
  z as zod
} from 'zod'

/**
 * List investors
 */
export const investorListQueryParams = zod.object({
  "investor_entity_ids": zod.array(zod.string()).optional()
})

/**
 * Create a new investor and associate it with an existing investor entity
 */
export const investorCreateBody = zod.object({
  "name": zod.string().min(1),"primary_contact_email": zod.string().optional(),"maybern_id": zod.string().min(1)
})

/**
 * Get an existing investor
 */
export const investorRetrieveParams = zod.object({
  "investorId": zod.string()
})

export const investorRetrieveResponseAnnotationsSetMin = 2;
export const investorRetrieveResponseAnnotationsSetMax = 2;

export const investorRetrieveResponse = zod.object({
  "annotations_set": zod.array(zod.array(zod.any()).min(investorRetrieveResponseAnnotationsSetMin).max(investorRetrieveResponseAnnotationsSetMax)).optional(),"name": zod.string().min(1),"primary_contact_email": zod.string().min(1),"maybern_id": zod.string().min(1),"id": zod.string().min(1),"customer_event_id": zod.string().min(1)
})

/**
 * Edit an existing investor
 */
export const investorUpdateParams = zod.object({
  "investorId": zod.string()
})

export const investorUpdateBody = zod.object({
  "name": zod.string().min(1),"primary_contact_email": zod.string().optional(),"maybern_id": zod.string().min(1)
})

export const investorUpdateResponseAnnotationsSetMin = 2;
export const investorUpdateResponseAnnotationsSetMax = 2;

export const investorUpdateResponse = zod.object({
  "annotations_set": zod.array(zod.array(zod.any()).min(investorUpdateResponseAnnotationsSetMin).max(investorUpdateResponseAnnotationsSetMax)).optional(),"name": zod.string().min(1),"primary_contact_email": zod.string().min(1),"maybern_id": zod.string().min(1),"id": zod.string().min(1),"customer_event_id": zod.string().min(1)
})

/**
 * Delete an existing investor
 */
export const investorDestroyParams = zod.object({
  "investorId": zod.string()
})

/**
 * Create an association between an investor and and one or more investor entities
 */
export const investorEntityRelationshipCreateParams = zod.object({
  "investorId": zod.string()
})

export const investorEntityRelationshipCreateBody = zod.object({
  "investor_entity_ids": zod.array(zod.string().min(1))
})

/**
 * Remove an investor entity from an investor
 */
export const investorEntityRelationshipsDestroyParams = zod.object({
  "investorId": zod.string()
})

export const investorEntityRelationshipsDestroyQueryParams = zod.object({
  "investor_entity_ids": zod.array(zod.string())
})

